import React, { memo, useEffect } from 'react';
import ClassCard from '../Card/ClassCard/ClassCard';
import styles from './ClassOrders.module.less';
import Default from '../../../static/order_lack.svg';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getEducationMineGradelist } from '../../../actions/education';
import Loading from '../../../components/Loading/Loading';
import InfiniteScroll from 'react-infinite-scroller';
import DefaultLogin from '../DefaultLogin/DefaultLogin';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';

const SelectMineInfo = createSelector(
  state => state.education,
  educations => educations.mine,
);

export default memo(({ node }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginStatus = useLoginStatus();

  // const
  const { gradeList, pagenation, error } = useSelector(SelectMineInfo);

  const jumpOther = () => {
    history.push(`${CONTEXT}/education/pceduSelect`);
  };

  const getData = refresh => {
    dispatch(
      getEducationMineGradelist({
        refresh,
        tab: 'pay',
        limit: 3,
        skip: pagenation.tab === 'pay' && !refresh ? (gradeList && gradeList.length) ?? 0 : 1,
      }),
    );
  };

  useEffect(() => {
    getData(true);
  }, []);

  const loadMore = () => {
    getData(false);
  };

  return (
    <div className={styles.class_orders}>
      {!loginStatus && <DefaultLogin />}
      {loginStatus && (
        <>
          {pagenation.loading && (
            <div>
              <Loading />
            </div>
          )}

          {!pagenation.loading && (
            <>
              {pagenation.count === 0 && (
                <div className={styles.default}>
                  <div>
                    <img src={Default} />
                  </div>
                  <div className={styles.describe}>
                    <span>您暂时还没有订单</span>
                    <span className={styles.jump_other} onClick={jumpOther}>
                      去逛逛
                    </span>
                  </div>
                </div>
              )}
              {pagenation.count !== 0 && (
                <InfiniteScroll
                  page={1}
                  loadMore={loadMore}
                  hasMore={gradeList.length < pagenation.count}
                  loader={
                    <div className="loader" key={0}>
                      ----------加载中----------
                    </div>
                  }
                  initialLoad={false}
                  useWindow={false}
                  getScrollParent={() => node}
                >
                  {gradeList.map((el, index) => (
                    <ClassCard key={index} {...el} />
                  ))}
                </InfiniteScroll>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
});
